import { FC } from 'react';
import Grid from '@mui/material/Grid';
import methodImg from '../../media/method.png';
import { Paper, Typography } from '@mui/material';
import useTranslations from '../global/translation/hooks/translation';
import Paragraphs from '../global/Paragraphs';
import { useTheme } from '@mui/material/styles';
import { useThemeContext } from '../global/ThemeContext';

const Method: FC = () => {
  const { currentLanguage, translations } = useTranslations();
  const theme = useTheme();
  const text = translations.label.methodText[currentLanguage];
  const paragraphs = text.split('\n\n');
  const { darkMode } = useThemeContext();
  return (
    <Grid my={6} py={2} container justifyContent="center" alignItems="center" sx={{ bgcolor: darkMode ? '#121212' : '#fff' }}>
      <Grid item xs={12} m={2}>
        <Typography
          variant="h4"
          fontWeight={300}
          sx={{
            color: darkMode ? '#FFF' : '#000',
          }}
          textAlign="center"
        >
          {translations.menuItems.method[currentLanguage]}
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper elevation={12} sx={{ p: 2, m: 2, bgcolor: darkMode ? '#232323' : theme.palette.background.paper }}>
          <Typography variant="subtitle2" fontWeight={300} color={theme.palette.text.primary} textAlign="justify">
            <Paragraphs paragraphs={paragraphs} />
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <div style={{ position: 'relative', paddingTop: '35%', margin: '16px' }}>
          <img
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'scale-down' }}
            src={methodImg}
            alt="Carrousel Image"
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default Method;
